import React from 'react'
import styles from './StatusBubble.module.css'
import classNames from 'classnames'

export function StatusBubble ({ variant, number, children }) {
  return (
    <div className={styles.root}>
      <div className={styles.bubbleContainer}>
        <div className={classNames(styles.joiningLine, variant !== 'empty' && styles.joiningLineFull)}/>
        <div className={classNames(styles.bubble, styles[`bubble${variant}`])}>{number}</div>
      </div>
      <div className={styles.childrenContainer}>
        {children}
      </div>
    </div>
  )
}
